import styled from 'styled-components'
import Link from 'next/link'
import { Typography } from 'common/typography'
import { SecondaryButton } from 'common/button'

const LastLessonStyled = styled.div`
  .last-lesson {
    display: flex;
    gap: .5rem;
    align-items: center;
  }
`

const CourseProgressStyled = styled.div`
  gap: 0rem!important;
  .course-progress-title {
    display: flex;
    gap: 0.5rem;
    p {
      flex: 1;
    }
  }
  .course-progress-percent {
    font: var(--regularBold);
    color: var(--turquoise);
    margin-inline-start: .5rem;
  }
  .course-progress {
    margin-block-end: 1rem;
    margin-block-start: .5rem;
    display: flex;
    gap: 4px;
    align-items: center;
    &-container {
      flex: 1;
    }
    &-bar {
      height: .5rem;
      border-radius: 1rem;
      background: #10fefe33;
      position: relative;
      &:after {
        border-radius: 1rem;
        position: absolute;
        background: #10fefe;
        content: "";
        height: .5rem;
        right: ${({ progress }) => `${progress}%`};
        left: 0;
      }
    }
  }
`

function LastCourse({ course, lesson }) {
  return (
    <>
      {lesson.title ? (
        <LastLessonStyled className="progress-item">
          <Typography font="regularBold">Continúa viendo</Typography>
          <div className="last-lesson">
            <div>
              <img width="114" height="64" loading="lazy" src={lesson.thumbnail.link} alt="Thumbanail de la ultima clase vista" />
            </div>
            <div>
              <Typography font="p2Bold">{lesson.title}</Typography>
              {lesson.description ? (
                <Typography font="p2Regular">{lesson.description}</Typography>
              ) : null}
            </div>
          </div>
          <Link href={`/aprender/${course.slug}/${lesson.slug}`} passHref>
            <SecondaryButton fullWidth>
              Ver clase
            </SecondaryButton>
          </Link>
        </LastLessonStyled>
      ) : null}
      <CourseProgressStyled className="progress-item" progress={100 - course.progress}>
        <div className="course-progress-title">
          <Typography font="regularBold">
            {course.title || 'Curso de introducción al desarrollo web'}
          </Typography>
          <span className="course-progress-percent">
            {course.progress || '0'}
            %
          </span>
        </div>
        <div className="course-progress">
          <div className="course-progress-container">
            <div className="course-progress-bar" />
          </div>
        </div>
        <div className="btn-container">
          <Link href={`/aprender/${course.slug || '/cursos/desarrollo-web'}`} passHref>
            <SecondaryButton fullWidth>
              Continuar Curso
            </SecondaryButton>
          </Link>
          {/* <Link href={`/proyectos`} passHref>
            <OutlineButton fullWidth>
              Añadir proyecto
            </OutlineButton>
          </Link> */}
        </div>
      </CourseProgressStyled>
    </>
  )
}

export default LastCourse
